export var FunidAuthEvent;
(function (FunidAuthEvent) {
    FunidAuthEvent["Success"] = "funid-auth-success";
    FunidAuthEvent["Error"] = "funid-auth-error";
    FunidAuthEvent["AuthOpen"] = "funid-auth-open";
    FunidAuthEvent["AuthClose"] = "funid-auth-close";
})(FunidAuthEvent || (FunidAuthEvent = {}));
export var FunidAuthError;
(function (FunidAuthError) {
    FunidAuthError["EmailAlreadyInUse"] = "EMAIL_ALREADY_IN_USE";
    FunidAuthError["Fail"] = "FAIL";
})(FunidAuthError || (FunidAuthError = {}));
export var FunidViewType;
(function (FunidViewType) {
    FunidViewType["QrCode"] = "qrcode";
    FunidViewType["Info"] = "info";
})(FunidViewType || (FunidViewType = {}));
//# sourceMappingURL=funid-auth-model.js.map